import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  return (
    <Link
      to={`/article/${article.id}`}
      className="group block bg-background-50 rounded-xl border border-background-200/70 overflow-hidden transition-all duration-300 hover:border-primary-300 cursor-pointer"
    >
      <div className="aspect-[16/9] overflow-hidden">
        <img
          src={article.imageUrl}
          alt={article.title}
          title={article.title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="p-4 md:p-5">
        <div className="flex items-center gap-2 mb-3">
          <span className="px-2.5 py-0.5 bg-primary-100 text-primary-700 text-xs font-medium rounded-full whitespace-nowrap">
            {article.categoryName}
          </span>
          <span className="text-xs text-foreground-400">{article.date}</span>
        </div>
        <h3 className="font-heading font-semibold text-foreground-900 text-base mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
          {article.title}
        </h3>
        <p className="text-sm text-foreground-500 line-clamp-2 leading-relaxed">
          {article.description}
        </p>
        <div className="mt-4 flex items-center justify-between">
          <div className="flex items-center gap-1.5 text-xs text-foreground-400">
            <i className="ri-eye-line"></i>
            <span>{article.readCount > 10000 ? `${(article.readCount / 10000).toFixed(1)}万` : article.readCount} 阅读</span>
          </div>
          <div className="flex items-center gap-1.5 text-xs text-foreground-400">
            <i className="ri-user-line"></i>
            <span>{article.author}</span>
          </div>
        </div>
      </div>
    </Link>
  );
}